import React from "react";
import ConsolePortfolio from "./components/ConsolePortfolio/ConsolePortfolio";
import "bootstrap/dist/css/bootstrap.min.css"; 

function App() {
  return (
    <div className="App">
      <ConsolePortfolio />
    </div>
  );
}

export default App;
